var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnglish = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1803_2301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1803_2301)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.0988 1.27521L9.14332 8.52902V1.80001H14.8576V8.52902L25.0997 1.27521L26.3779 3.2649L18.2801 9.00001H24.0005V15H18.2801L26.3779 20.7351L25.0997 22.7248L14.8576 15.471V22.2H9.14332V15.471L-1.0988 22.7248L-2.37695 20.7351L5.72081 15H0.00046134V9.00001H5.72081L-2.37695 3.2649L-1.0988 1.27521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.002 8.69899L26.858 1.20001",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1543 15.3278L26.8862 22.2153",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8621 8.67939L-3.28906 1.49609",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9631 15.2444L-3.28906 23.0794",
    stroke: "#DB1F35",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.8H10.2857V21H13.7143V13.8H24V10.2H13.7143V3H10.2857V10.2H0V13.8Z",
    fill: "#E6273E"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnglish);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/english.2fd73512f3e72231bb3f5ab267a62af2.svg";